import React from "react";

const Header = ({ title = "", subtitle = null }) => {
  if (subtitle) {
    if (typeof subtitle === "function") {
      subtitle = subtitle();
    } else {
      subtitle = (
        <h3 className="mt-4 max-w-4xl text-md leading-[1.5] text-center">
          {subtitle}
        </h3>
      );
    }
  }

  return (
    <div>
      <h1 className="text-[40px] font-bold leading-[1.2] text-center">
        {title}
      </h1>
      {subtitle && subtitle}
    </div>
  );
};

export default Header;
